export const iconFontAwesomeDesignPenToSquare = (
	<i className="fa-solid fa-pen-to-square"></i>
);
